import { ModalProps } from '@chakra-ui/react';
import SendIcon from '@mui/icons-material/Send';
import Modal from '@/trio-ui/Modal';
import * as Styles from './SendConfirmationModal.styles';

type SendConfirmationModalProps = Pick<ModalProps, 'onClose' | 'isOpen'> & {
  actionMessage: string;
  onConfirmHandler: () => void;
  isButtonDisabled?: boolean;
};

export default function SendConfirmationModal({
  isButtonDisabled,
  actionMessage = 'it will be sent to the subject. This action cannot be undone.',
  onClose,
  onConfirmHandler,
  isOpen,
}: SendConfirmationModalProps): JSX.Element {
  const BodyMessage = (
    <Styles.Message>Once you hit “Yes, send it”, {actionMessage}.</Styles.Message>
  );

  return (
    <Modal
      isButtonDisabled={isButtonDisabled}
      modalId="send-confirmation-modal"
      headerIcon={SendIcon}
      isCentered
      size="sm"
      modalTitle="Are you sure?"
      bodyRender={BodyMessage}
      isOpen={isOpen}
      onClose={onClose}
      onConfirmLabel="Yes, send it"
      onConfirmClick={onConfirmHandler}
    />
  );
}
